import { render, staticRenderFns } from "./UcAddressList.yaml?vue&type=template&id=34a61306&component"
import script from "./UcAddressList.yaml?vue&type=script&lang=ts&component"
export * from "./UcAddressList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports